import React from 'react';
export function CampaignPlainTextIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 3a1 1 0 011-1h18a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm2 1v16h16V4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7a1 1 0 011-1h10a1 1 0 011 1v2.083a1 1 0 11-2 0V8h-3v8h1.083a1 1 0 110 2H9.917a1 1 0 110-2H11V8H8v1.083a1 1 0 01-2 0V7z"
  }));
}